<template>
  <div class="wapper" v-if="isShow">
    <div class="header">
      <span class="icontemp stemp-close" @click="close"></span>
      文件下载
    </div>
    <div class="content">
      <div class="file-container" v-for="(f, i) in fileList" :key="i">
        <img :src="getFileType(f.ext)" alt="" class="icon" />
        <div class="file-info">
          <p class="name">{{ f.name }}</p>
          <p class="size">{{ formatSize(f.size) }}</p>
        </div>
        <span class="icontemp download-b" @click="download(f)"></span>
      </div>
    </div>
    <van-dialog
      v-model="showDownloadForm"
      title="文件下载"
      show-cancel-button
      confirm-button-text="提交"
      :before-close="beforeDownloadFormClose"
    >
      <div style="height: 80px; padding: 10px 0px;">
        <van-field
          class="email-input pxtovw-ignore"
          v-model="userEmail"
          label="邮箱: "
          placeholder="请输入邮箱地址"
          border
          :error-message="emailErrorMsg"
          @input="onInputEmail"
        />
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { buildFlieData, buildTableMethod, mounted } from "../../common/file";
export default {
  name: "File",
  data() {
    return buildFlieData({});
  },
  methods: buildTableMethod({
    getFileType(ext) {
      let type = "";
      if (
        [
          "jpg",
          "gif",
          "png",
          "bmp",
          "pdf",
          "ppt",
          "pptx",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "zip"
        ].includes(ext)
      ) {
        type = ext;
      } else {
        type = "other";
      }
      return require("../../assets/images/file-img-" + type + ".jpg");
    },
    formatSize(bLength) {
      bLength = parseInt(bLength);
      if (!bLength) {
        return "0B";
      }
      var unit = {
        B: 1,
        KB: 1024,
        MB: 1048576,
        GB: 1073741824,
        TB: 1099511627776
      };
      var flag = "";
      for (var i in unit) {
        if (bLength > unit[i]) {
          flag = i;
        } else {
          break;
        }
      }
      var result = (bLength / unit[flag])
        .toFixed(2)
        .toString()
        .replace(".00", "");
      if (/\.[1-9]0/.test(result)) {
        result = result.substring(0, result.length - 1);
      }
      return result + flag;
    }
  }),

  created() {
    mounted(this);
  }
};
</script>
